module.exports = __webpack_public_path__ + "img/American-Credit-logo-TM-320w.8e88227.png";